import React from 'react';

const ArrowRightIcon = (props) => (
  <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.66671 5L12.3334 5M12.3334 5L8.33337 9M12.3334 5L8.33337 1" stroke="#00ADEF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ArrowRightIcon; 